
import O1HD from "../../../../../engines/gameEngine";
import PageBase from "../../../../../engines/modules/uiModule/PageBase";
import { OilFieldBuyPrams } from "../../../../../engines/modules/uiModule/UIPrams";
import { getKaoguItemConfig, getKaoguMountainConfig, KaoguItemInfo, KaoguMountainInfo } from "./config/kaoguMountainConfig";


const { ccclass, property } = cc._decorator;

@ccclass
export default class insideItemPage extends PageBase {
    @property({ type: cc.Sprite, displayName: "矿山图片" })
    img_oilfield: cc.Sprite = null;

    infoData: KaoguItemInfo = null

    callBack: () => void = null;
    async OnPageOpen(prams?: OilFieldBuyPrams) {
        if (prams) {
            this.infoData = getKaoguItemConfig[prams.id];
            this.callBack = prams.callBack;
        }
        super.OnPageOpen(prams)
    }
    clickTime: number = null;
    onClickMine() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        this.ClosePage();
        this.callBack && this.callBack();
    }
}